export const FETCH_DONATIONS = '/donations';
export const CREATE_DONATIONS = '/donations';
export const FETCH_DONATION_SUMMARY = '/donation/summary';
export const FETCH_COUNTRY_SUMMARY = '/donation/country/';
export const FETCH_DONATIONS_FROM_SHEET = '/donations/sheet';